<template>
    <div>    
        <section class="page-section bg-light" id="listen">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12 text-left">
                        <a target="_blank"  href="https://soundcloud.com/itstheraj/era-of-women-featuring-jessica-franklin">
                            <img src="/img/era_of_women.webp" height="300px" class="rounded mx-auto d-block mr-2 mb-3"/>
                        </a>
                        <hr>
                        <h2 class="">
                            <b>Era of Women</b> by The Raj!
                        </h2>
                        <p class="mb-1 text-muted text-sm">Listen</p>
                        <a target="_blank"  href="https://soundcloud.com/itstheraj/era-of-women-featuring-jessica-franklin">
                            <img class="mr-2" src="img/soundcloud.svg" height="25px" />
                        </a>
                        <p class="mt-4">
                            <b>Era of Women</b> is an experimental album that documents the latest wave of feminism post the Dobbs decision to repeal Roe vs Wade. 
                            The story is told through the audio footage from modern feminists such as Professor Angela Davis, Lieutenant Governer Peggy Flanagan (of Minnesota), Justice Sonia Sotomayor, and Malala Yousafzai. The album is a single 15 minute 20 second piece, and was displayed in the 2024 Exhibit <b>The Technicolor Truth: Art for the Anti-Antagonists</b>, a fine art exhibit at Grace Trinity Community Church in Uptown, Minneapolis. The album played on surround sound speakers on a loop throughout the exhibit.
                         </p>
                         <p>
                            The album features <b>Joe Moran</b> on guitar and <b>Jessica Franklin</b> on vocals and is available for free on soundcloud.
                          </p>
                    </div>
                </div>
                
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: '',
    components: {
    },
    data: function(){
        return{
            items: [
            ]
        }
    }
}
</script>